import { ILocaleLegacy } from '@locales/interfaces';

/**
 * @deprecated
 * @todo
 * These are legacy translations. Some of them are used silently (come from BE), while others are outdated.
 * Please remove keys if you are 100% sure that they are not used in the project anymore.
 */
export const pt = {
  IBCorporate: 'IB corporativo',
  IBIndividual: 'IB Individual',
  MAMIndividual: 'MAM individual',
  MAMMasterWithLPOA: 'MAM individual',
  MarkupConfirmation: 'Confirmação de margem',
  UserCorporate: 'Usuário corporativo',
  UserIndividual: 'Usuário individual',
  UserJoint: 'Usuário conjunto',
  account: {
    bankingDetails: 'Dados bancários',
    createANewAccount: 'Criar uma nova conta',
    register: 'Registro',
    registerSignInTitle: 'Já é usuário?',
  },
  admin: {
    user: {
      fields: {
        isMam: 'É MAM',
        isSales: 'Você é um usuário de vendas',
      },
    },
    tabs: {
      tradingSettings: {
        tradingAccountSettings: 'Configurações da conta de negociação',
        setIBCode: 'Conjunto de códigos IB',
      },
    },
    reports: {
      ftdUtmReport: {
        headerTitle: 'Relatório FTD_UTM',
        menuTitle: 'Relatório FTD_UTM',
      },
    },
  },
  adminSocialTrading: {
    title: 'Perdagangan Social',
    investorAccountDetails: {
      tradingAccountName: 'Nome da conta de negociação',
      balance: 'Saldo',
      login: 'Acesso',
    },
    masterAccountDetails: {
      copyType: 'Tipo de cópia',
      groupMappingType: 'Tipo de mapeamento de grupo',
      login: 'Acesso',
    },
  },
  backgroundJobs: {
    recurring: {
      title: 'Empregos recorrentes',
    },
  },
  bonuses: {
    collectBirthdayGift: 'Recolha seu presente de aniversário',
    availableTable: {
      bonusSize: 'Tamanho do bônus',
    },
  },
  errors: {
    shared: {
      recordWasNotFound: 'Não se encontra na página',
    },
    captcha: {
      captchaServerIsUnavailable:
        'O servidor Captcha não está disponível. Atualize a página e volte a tentar. Se o problema persistir, entre em contato com suporte por chat on-line ou por e-mail para {{clientSupportEmail}}',
    },
    files: {
      fileWasNotUploaded: 'O arquivo não foi carregado',
    },
    mam: {
      linkIsInactive: 'O link usado não está ativo',
    },
    trading: {
      profitSharingLimitWasExceeded:
        'Observe que o limite máximo de participação nos lucros foi excedido. O limite máximo é {{maxLimit}}%.',
      notEnoughMoney:
        'Pedimos desculpa, mas não tem fundos suficientes na sua conta de negociação para processar o saque solicitado. Certifique-se de ter saldo suficiente disponível antes de tentar um saque. Observe que, além do saldo disponível, você também deve considerar o nível de margem livre necessário para saques.',
    },
    copyTrading: {
      equityIsLessOrEqualZero:
        'A conta Master não está qualificada para ser copiada neste momento. Tente novamente mais tarde.',
    },
    securityCode: {
      emptyValue: 'O valor de segurança inserido (senha ou código PIN) não pode estar vazio ou nulo',
      invalidLength: 'O valor de segurança inserido (senha ou código PIN) deve conter {{0}} caractere(s)',
      invalidMinLength: 'O valor de segurança inserido (senha ou código PIN) deve conter pelo menos {{0}} caractere(s)',
      invalidMaxLength: 'O valor de segurança inserido (senha ou código PIN) não deve exceder {{0}} caractere(s)',
      manyRepeatedValues:
        'O valor de segurança inserido (senha ou código PIN) não deve ter mais de {{0}} caracteres repetidos',
      missingNumericValues: 'O valor de segurança inserido (senha ou código PIN) deve conter caracteres numéricos',
      containsNumericValues:
        'O valor de segurança inserido (senha ou código PIN) não deve conter nenhum valor numérico',
      missingLowerCaseValues: 'O valor de segurança inserido (senha ou código PIN) deve conter caracteres minúsculos',
      containsLowerCaseValues: 'O valor de segurança inserido (senha ou código PIN) não deve conter valores minúsculos',
      missingUpperCaseValues: 'O valor de segurança inserido (senha ou código PIN) deve conter caracteres maiúsculos',
      containsUpperCaseValues: 'O valor de segurança inserido (senha ou código PIN) não deve conter valores maiúsculos',
      missingSpecialValues: 'O valor de segurança inserido (senha ou código PIN) deve conter caracteres especiais',
      containsSpecialValues: 'O valor de segurança inserido (senha ou código PIN) não deve conter caracteres especiais',
      passwordChangeLimit: 'O limite de tentativas de alteração de senha foi excedido. Aguarde e tente novamente',
    },
    user: {
      accountHasBeenDisabled: 'Desculpe pelo transtorno, mas a conta {{0}} foi desativada',
      ageIsAboveMaxAllowed: 'Não aceitamos inscrições de menores de {{0}} ou maiores de {{1}} anos.',
      ageIsUnderMinAllowed: 'Não aceitamos inscrições de menores de {{0}} anos.',
      cantChangeLanguage: 'Não é possível alterar o idioma',
      fieldIsRequired: 'O campo {{0}} é obrigatório',
      ibCodeIsIncorrect: "O código IB '{{0}}' está incorreto. Por favor insira um código IB válido",
      invalidCredentials: 'Nome de usuário {{0}} e/ou senha inválidos',
      invalidLengthOfPhoneNumber: 'O comprimento do número de telefone é inválido. Tente novamente',
      invalidLink: 'O link é inválido',
      invalidPhoneNumberLength: 'O comprimento do número de telefone é inválido. Tente novamente',
      onlyLatinCharactersAndDigitsAndSpecialSymbolsCanBeUsed:
        'Apenas caracteres latinos, dígitos e símbolos especiais podem ser usados para o campo {{0}}',
      onlyLatinCharactersAndDigitsCanBeUsed: 'Somente caracteres latinos e dígitos podem ser usados no campo {{0}}',
      onlyLatinCharactersCanBeUsed: 'Apenas caracteres latinos podem ser usados no campo {{0}}',
      onlyChineseCharactersCanBeUsed: 'Only chinese characters can be used for {{0}} field',
      personalDataNotEntered: 'Dados pessoais não são inseridos',
      userCannotBeRestored:
        'Desculpe, o registro não pode ser restaurado porque o e-mail ou número de telefone deste perfil já está em uso com outro perfil. Exclua o perfil com o mesmo e-mail ou número de telefone para restaurar este.',
      userDoesntExist: 'O usuário {{0}} não existe',
      userEmailAlreadyExists: 'O e-mail do usuário já foi cadastrado no sistema',
      userPhoneAlreadyExists: 'O telefone do usuário já foi cadastrado no sistema',
      cantUpdateProfileActualStatus: 'Não é possível atualizar a conta {{0}}, estado atual = {{1}}',
    },
  },
  formats: {
    formatFloat: '{{value, float}}',
    formatMoney: '{{value, money}}',
  },
  forms: {
    dragFile: 'ou arraste aqui seus arquivos',
    exportFormat: 'Formato da exportação',
    getCode: 'Obter código',
    hide: 'oculto',
    limitMessage: '{{limit}} caracteres restantes',
    resend: 'Reenviar',
    seconds: 'segmento',
    show: 'Mostrar',
  },
  headerWithBalance: {
    serverTime: 'Hora do servidor',
    failedToFetchServerTime: 'Não foi possível obter a hora do servidor',
    view: 'Vista',
  },
  investors: {
    blackList: 'Lista negra',
  },
  legal: {
    clientAgreement: 'Contrato do cliente',
    privacyPolicy: 'Política de privacidade',
  },
  legalTradingPlatform: {
    data: 'Dados',
  },
  masterProfile: {
    aboutMaster: 'Sobre o fornecedor',
    infoFields: {
      ibCode: 'Código IB',
    },
  },
  masters: {
    fields: {
      masterNickname: 'Apelido do fornecedor',
      rating: 'Posição de classificação',
    },
  },
  menu: {
    deposit: 'Depósito',
  },
  messages: {
    CopyTrading: {
      InvestorAccountWasLinked: "A conta seguidora começou a copiar a conta mestre '{{MasterAccountName}}'.",
      InvestorAccountWasOpened:
        "A conta de seguidor foi criada. A conta seguidora começou a copiar a conta mestre '{{InvestorAccountName}}'.",
      InvestorAccountWasUnlinked: "A conta do seguidor foi parou de copiar a conta mestre '{{MasterAccountName}}'.",
      MasterAccountWasChanged:
        'A conta mestra foi modificada. (Participação nos lucros={{ProfitSharing}}, Método de alocação={{AllocationMethod}})',
      MasterAccountWasLinked: "A conta do seguidor '{{InvestorAccountName}}' começou a copiar a conta mestre.",
      MasterAccountWasOpened:
        'A conta mestra foi criada. (Participação nos lucros={{ProfitSharing}}, Método de alocação={{AllocationMethod}})',
      MasterAccountWasUnlinked: "A conta do seguidor '{{InvestorAccountName}}' parou de copiar a conta mestre.",
    },
  },
  modal: {
    error: 'Erro',
    notification: 'Notificação',
    ok: 'OK',
  },
  operationHistory: {
    filterName: 'Procurar',
    placeholder: 'Por favor, insira',
  },
  pageTitles: {
    admin: {
      financialIdentity: {
        children: {
          cards: 'cartões',
        },
      },
    },
  },
  partnership: {
    salesTitle: 'Ventas',
    ibInfo: {
      detailsTitle: 'Detalhes IB',
      nextRebatePayment: 'Próximo pagamento de descontos',
      statistics: {
        closetTradersReport: {
          type: 'Tipo',
        },
        tradingVolReport: {
          subIb: 'Sub-IB',
        },
      },
    },
    ibSettings: {
      referralLinkError:
        '¡Los márgenes são incorretos! Entre em contato com nosso equipamento de suporte para obter melhores resultados',
    },
    salesUserInfo: {
      aeCode: 'Código AE',
    },
  },
  profile: {
    adult: 'Eu tenho mais de 18 anos',
    code: 'Código',
    country: 'País',
    documentsUploaded: 'Documentos enviados',
    isAgreeWithTermsAndConditions: 'Aceito o <0>Contrato do Cliente</0> e a <1>Política de Privacidade</1>',
    pleaseValidateAccountToDeposit:
      'Seus dados pessoais exigem verificação pela equipe de conformidade da {{brokerName}}. Antes de prosseguir com o depósito, você deve enviar uma digitalização do seu documento de identidade',
    successChangeDescription: 'As alterações foram salvas!',
    warningMessage: {
      profileIsBeingVerified: 'Seu perfil está sendo verificado, pode demorar alguns segundos',
    },
  },
  psp: {
    accountsFetchFailErr: 'Erro ao obter contas',
    confirmEveryTransaction: 'Confirmando todas as transações, os depósitos podem levar até 24 horas',
    deposit: {
      depositForm: {
        accountNameTitle: 'Nome da conta',
        addressLine2: 'Endereço da linha 2',
        beneficiaryAccountNumberTitle: 'Número da Conta do Beneficiario',
        beneficiaryBankHint: 'Selecione o número da conta bancária',
        beneficiaryBankNameHint: 'Nome do banco, por ex. por exemplo. (Banco Registrado Padrão)',
        cardNameTitle: 'Nome do cartão',
        localDepositFileHint: 'Anexe um documento confirmando o pagamento, se necessário',
      },
      depositTitle: 'Fundos de depósito',
      notice: 'Os depósitos estão disponíveis apenas para contas verificadas',
      warnToSubmitPersonalDetails:
        'Para fazer um depósito, envie seus dados pessoais. Certifique-se de que eles correspondem aos detalhes do seu ID',
    },
    localAgentTable: {
      login: 'Do utilizador',
    },
    operationsFetchFailErr: 'Erro ao obter operações',
    operationsTable: {
      documentTitle: 'Documento',
      operationsTableTitle: 'Operações recentes',
      paymentSystemTitle: 'Sistema de pagamento',
    },
    pluginInfoFetchFailErr: 'Não foi possível obter informações do plugin',
    pluginNotFound: 'Plug-in não encontrado',
    pluginsFetchFailErr: 'Não foi possível obter plug-ins',
    preAuthorizedBanking: 'Banco pré-autorizado',
    qrCodeCryptoNotice:
      'O código QR é apenas para uso único. Não escaneie este código em um aplicativo criptográfico mais de uma vez, caso contrário seu pagamento será suspenso.',
    qrCodeCryptoTitle: 'Código QR para aplicativo de criptografia',
    resentOperationsTitle: 'Operações recentes',
    transfer: {
      transactionDetailsTitle: 'Dados de transação',
      transferForm: {
        amountError: 'Valor de transferência disponível excedido',
        currencyTitle: 'Distintivo',
      },
    },
    uploadBankStatementWithBankName:
      'Faça upload de um extrato bancário contendo o nome do banco, seu nome completo e o número da conta bancária',
    uploadPayslip: 'Carregue o recibo bancário do seu depósito',
    uploadYourDocument: 'Confirme seu depósito enviando seu extrato bancário',
    withdrawal: {
      notice: 'Os Saques estão disponíveis apenas para contas verificadas',
      withdrawalTitle: 'Sacar fundos',
      withdrawalForm: {
        bankNameTitle: 'Nome do banco',
        beneficiaryCryptoWalletHint: 'Um número de carteira com dinheiro criptomoeda será enviado para',
        beneficiaryCryptoWalletTitle: 'Carteira Cripto Beneficiária',
        confirmTitle: 'Confirmar informações de Saque',
      },
    },
  },
  settings: {
    docsForm: {
      documentNumberHint: 'Verifique se o número de identificação é igual à foto',
      documentTypeHint: 'Certifique-se de fornecer uma foto de alta qualidade ou digitalização de um documento válido',
      uploadedDocumentsTable: {
        docNameTitle: 'Nome do Documento',
        documentNumber: 'Número do documento',
        typeTitle: 'Tipo de documento',
      },
    },
    profileForm: {
      editProfileTitle: 'Editar Perfil',
      proceedToDeposit: 'Prossiga para depositar',
      saveUserSuccessMessage: 'O perfil foi salvo com sucesso',
      userDetailsErrorMessage: 'Não foi possível obter o perfil do usuário',
      verifyPersonalDetails: 'Verifique dados pessoais',
      verifyProfileBtn: 'Verifique o perfil',
    },
  },
  socialTradingModal: {
    copyHint: 'Sua conta {{account}} irá parar de copiar o provedor {{oldMaster}} e começar a copiar {{newMaster}}',
  },
  tradingAccounts: {
    accountDetailsTitle: 'Conta de negociação',
    accountHistoryForm: {
      closeTimeTitle: 'Hora de cierre',
    },
    changeTradingAccountName: 'Alterar o nome da conta de negociação',
    connectedAccounts: 'Contas conectadas',
    currency: 'Divisa',
    depositForm: {
      amountTitle: 'Importar',
      errorMessage: 'Erro ao depositar fundos',
      successMessage: 'O depósito foi realizado com sucesso',
    },
    descriptionPlaceholder: 'Insira recomendação para seus seguidores',
    fetchServersErr: 'Não se poderia obter os servidores',
    ibCode: 'IB (opcional)',
    notRows: 'Não há filas que mostrem',
    openAccountModalSubTitle:
      'A maior variedade de instrumentos de negociação: divisões, metais. Condições operacionais padrão.',
    tradingPlatforms: 'Plataformas de negociação',
    transferForm: {
      title: 'transferir fundos',
    },
    withdrawForm: {
      amountTitle: 'Quantia',
      errorMessage: 'Falha ao salvar alavancagem',
      successMessage: 'O Saque foi bem-sucedido',
    },
  },
} satisfies ILocaleLegacy;
